


















import { Component, Vue } from 'vue-property-decorator'

@Component
export default class TokenExpired extends Vue {
  jumpToLogin() {
    this.$router.push({ name: 'login' })
  }
}
